import axios from 'axios';
import Conversation, { GenericResponse } from '../models/Conversation';
import { errorMessage } from '../models/Constants';
/***
THIS WORKS-
curl -X POST -u "apikey:HQ255mmjDZN-qA76CieLqnFxKzHBnREaynaivfVp6g_i" --header "Content-Type:application/json" --data "{\"input\": {\"text\": \"Hello\"}}" "https://api.us-south.assistant.watson.cloud.ibm.com/v1/workspaces/bd12e787-087e-4b52-a8c9-1a2f4d652f2b/message?version=2020-04-01"
*/
//const URL:string = "https://api.us-south.assistant.watson.cloud.ibm.com/v1/workspaces/f038a7e7-ab28-440a-9a72-053465104446/message?version=2020-04-01" //ENGLISH
const URL:string = "https://api.us-south.assistant.watson.cloud.ibm.com/v1/workspaces/d95155d7-1dbc-438e-b9bb-8b405bc137dd/message?version=2020-04-01" //HINDI

const API_KEY = process.env.REACT_APP_API_KEY!;
const API_USERNAME = process.env.REACT_APP_USERNAME!;

export const startConversation = () => {
  return new Promise((resolve, reject) => {
    axios.post(
      URL,
      {
        input: {
          text: "Hello"
        }
      },
      {
        headers: {'Content-Type':'application/json'},
        auth: {username:API_USERNAME,password:API_KEY}
      }
    ).then(function (response) {
      const gResponses = response.data.output.generic.map((res: any)=>{
        const genRes:GenericResponse = new GenericResponse(res);
        switch (res.response_type) {
          case 'option':
            genRes.parseOptionResponse(response.data.context);
            return genRes;
          case 'text':default:
            genRes.parseTextResponse();
            return genRes;  
        }
      });
      resolve({context: response.data.context, genericResponses: gResponses} as Conversation);
    })
    .catch(function (error) {
      reject(error);
    });
  })
}


export const sendMessage = (messageText: any, context: any) => {
  return new Promise((resolve, reject) => {
    axios.post(
      URL,
      {
        input: {
          text: messageText
        },
        context: context
      },
      {
        headers: {'Content-Type':'application/json'},
        auth: {username:API_USERNAME,password:API_KEY}
      }
    ).then(function (response) {
      if(!response.data.output.generic){
        response.data.output.generic = [{response_type: "text", text: errorMessage[Math.floor(Math.random() * errorMessage.length)]}]
      }
      const gResponses = response.data.output.generic.map((res: any)=>{
        const genRes:GenericResponse = new GenericResponse(res);
        switch (res.response_type) {
          case 'option':
            genRes.parseOptionResponse(response.data.context);
            return genRes;
          case 'image':
            genRes.parseImageResponse();
            return genRes;
          case 'text_link':
            genRes.parseTextLinkResponse();
            return genRes;
          case 'text':default:
            genRes.parseTextResponse();
            return genRes;
        }
      });

      resolve({context: response.data.context, genericResponses: gResponses} as Conversation);
    })
    .catch(function (error) {
      reject(error);
    });
  })
}